import translations from './translation.json';
import Documents from './Documents.json';
import Users from './Users.json';
import Rooms from './Rooms.json';
import Report from './Report.json';
import Settings from './Settings.json';
import Billing from './Billing.json';
import Organizations from './Organizations.json';
import Chats from './Chats.json';
import Confirm from './Confirm.json';
import Header from './Header.json';
import Sides from './Sides.json';
import Logs from './Logs.json';
import Tariffs from './Tariffs.json';
import FAQ from './FAQ.json';
import MobileApp from './MobileApp.json'
import Analytics from './Analytics.json';
import RecycleBin from './RecycleBin.json';
import Search from './Search.json';
import PersonalInfo from './PersonalInfo.json';

const es = {
  ...translations,
  Analytics,
  Documents,
  Logs,
  Users,
  Report,
  Rooms,
  Settings,
  Billing,
  Organizations,
  Chats,
  Confirm,
  Header,
  Sides,
  Tariffs,
  FAQ,
  MobileApp,
  RecycleBin,
  Search,
  PersonalInfo,
};

export default es;
